import { IServerTariff } from 'types';

import { IDraggableData } from './interfaces';

export const tariffInitializer = (tariff: IServerTariff): IDraggableData => {
  return {
    id: tariff.id,
    original: {
      ...tariff,
    },
  };
};
